import { render, staticRenderFns } from "./MediaKindPlayer.vue?vue&type=template&id=54e881fa&"
import script from "./MediaKindPlayer.ts?vue&type=script&lang=ts&"
export * from "./MediaKindPlayer.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports